import React from "react";
import cn from "classnames";
import { Field } from "formik";

import styles from "./styles.module.scss";

const FormikCheckboxField = ({ label, id, labelClasses = "", ...props }) => (
    <>
        <Field className={styles.checkbox} component="input" type="checkbox" id={id} {...props} />
        <label className={cn(styles.label, labelClasses)} htmlFor={id}>
            {label}
        </label>
    </>
);

export default FormikCheckboxField;
